(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["airline-compatibility-drawer"]) return;
  try {
    
  (() => {
    if (customElements.get('airline-compatibility')) return;

    class AirlineCompatibility extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('x-drawer');
        this.rows = Array.from(this.querySelectorAll('[data-airline-row]'));
        this.search = this.querySelector('[data-airline-search]');
        this.toggle = this.querySelector('[data-airline-toggle]');
        this.empty = this.querySelector('[data-airline-empty]');
        this.counts = this.querySelectorAll('[data-airline-count]');
        this.productWrap = this.querySelector('[data-airline-product]');
        this.productImage = this.querySelector('[data-airline-product-image]');
        this.productTitle = this.querySelector('[data-airline-product-title]');
        this.productSubtitle = this.querySelector('[data-airline-product-subtitle]');
        this.productDimensions = this.querySelector('[data-airline-product-dimensions]');
        this.labelCompatible = this.dataset.labelCompatible || '';
        this.labelIncompatible = this.dataset.labelIncompatible || '';

        this.rows.forEach((row) => {
          row.searchKey = this.normalize(row.dataset.name || '');
          row.statusEl = row.querySelector('[data-airline-status]');
        });

        if (!this.drawer) return;

        this.drawer.addEventListener('dialog:before-show', (event) => this.populate(event.detail.activator));

        if (this.search) {
          this.search.addEventListener('input', () => this.filter());
        }

        if (this.toggle) {
          this.toggle.addEventListener('change', () => this.filter());
        }
      }

      populate(activator) {
        if (!activator) return;

        const data = activator.dataset;
        const handles = new Set((data.airlineHandles || '').split(',').filter(Boolean));

        this.rows.forEach((row) => {
          const compatible = handles.has(row.dataset.handle);
          row.classList.toggle('is-compatible', compatible);
          row.classList.toggle('is-incompatible', !compatible);
          if (row.statusEl) {
            row.statusEl.textContent = compatible ? this.labelCompatible : this.labelIncompatible;
          }
        });

        this.counts.forEach((el) => {
          el.textContent = data.airlineCount || String(handles.size);
        });

        this.setText(this.productTitle, data.productTitle);
        this.setText(this.productSubtitle, data.productSubtitle);
        this.setText(this.productDimensions, data.productDimensions);

        if (this.productImage) {
          if (data.productImage) {
            this.productImage.src = data.productImage;
            this.productImage.alt = data.productTitle || '';
          } else {
            this.productImage.removeAttribute('src');
          }
        }

        if (this.productWrap) {
          this.productWrap.hidden = !(data.productTitle || data.productImage);
        }

        if (this.search) this.search.value = '';
        if (this.toggle) this.toggle.checked = true;
        this.filter();
      }

      setText(el, value) {
        if (!el) return;
        el.textContent = value || '';
        el.hidden = !value;
      }

      normalize(value) {
        return value.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
      }

      filter() {
        const query = this.search ? this.normalize(this.search.value.trim()) : '';
        const compatibleOnly = this.toggle ? this.toggle.checked : false;
        let visible = 0;

        this.rows.forEach((row) => {
          const matchesText = !query || (row.searchKey || '').includes(query);
          const matchesCompatible = !compatibleOnly || row.classList.contains('is-compatible');
          const show = matchesText && matchesCompatible;
          row.hidden = !show;
          if (show) visible += 1;
        });

        if (this.empty) this.empty.hidden = visible !== 0;
      }
    }

    customElements.define('airline-compatibility', AirlineCompatibility);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capsule"] && !Shopify.designMode) return;
  try {
    
  class CapsuleCarousel extends HTMLElement {
    #index = 0;
    #count = 0;
    #items = [];
    #titles = [];
    #button = null;
    #buttonLabel = null;
    #toggle = null;
    #timer = null;
    #pauseTimer = null;
    #autoplaySeconds = 0;
    #busy = false;
    #centerWidth = 0;
    #hovering = false;
    #paused = false;

    connectedCallback() {
      this.#count = Number(this.dataset.slideCount);
      this.#items = [...this.querySelectorAll('[js-gallery-item]')];
      this.#titles = [...this.querySelectorAll('[js-title]')];
      this.#button = this.querySelector('[js-button]');
      this.#buttonLabel =
        this.#button?.querySelector('[js-button-content]') ?? this.#button;
      this.#toggle = this.querySelector('[js-autoplay-toggle]');

      if (!this.#items.length) return;

      this.#index = this.#count > 1 ? this.#count : 0;
      this.#applySlots(true);
      this.#applyMeta();

      if (this.#count <= 1) return;

      this.#autoplaySeconds = Number(this.dataset.autoplay);
      this.#paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.#syncToggle();
      this.#startAutoplay();

      this.#toggle?.addEventListener('click', () => {
        this.#paused = !this.#paused;
        this.#syncToggle();
        if (this.#paused) this.#stopAutoplay();
        else this.#startAutoplay();
      });

      // Hover pause is limited to the CTA: its label and href swap with the active
      // slide, so they must not change under the cursor. Pausing on the whole
      // component would stop autoplay whenever the cursor rests on this tall
      // section, and would make the toggle look broken (already stopped on hover).
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      if (this.dataset.pauseOnHover === 'true' && this.#autoplaySeconds > 0 && this.#button) {
        this.#button.addEventListener('mouseenter', () => {
          if (!canHover.matches) return;
          this.#hovering = true;
          this.#stopAutoplay();
        });
        this.#button.addEventListener('mouseleave', () => {
          this.#hovering = false;
          this.#startAutoplay();
        });
      }

      this.addEventListener('click', (event) => {
        const item = event.target.closest('[js-gallery-item]');
        if (!item) return;
        const target = this.#items.indexOf(item);
        // The centered image follows its link; side images only bring their slide to the center.
        if (target === -1 || target === this.#index) return;
        event.preventDefault();
        this.#slideTo(target);
        this.#pauseAutoplay();
      });

      this.addEventListener('shopify:block:select', (event) => {
        const index = this.#items.findIndex(
          (item) => item.dataset.blockId === event.detail.blockId,
        );
        if (index === -1) return;

        this.#index = index;
        this.#applySlots(event.detail.load);
        this.#applyMeta();
      });
    }

    disconnectedCallback() {
      this.#stopAutoplay();
    }

    #syncToggle() {
      this.#toggle?.setAttribute('aria-pressed', String(this.#paused));
    }

    #startAutoplay() {
      if (this.#autoplaySeconds <= 0) return;
      if (this.#paused || this.#hovering) return;
      this.#stopAutoplay();
      this.#timer = window.setInterval(
        () => this.#next(),
        this.#autoplaySeconds * 1000,
      );
    }

    #stopAutoplay() {
      if (this.#timer) window.clearInterval(this.#timer);
      this.#timer = null;
      if (this.#pauseTimer) window.clearTimeout(this.#pauseTimer);
      this.#pauseTimer = null;
    }

    #pauseAutoplay(ms = Math.max(this.#autoplaySeconds * 2000, 5000)) {
      if (!this.#autoplaySeconds) return;
      this.#stopAutoplay();
      this.#pauseTimer = window.setTimeout(() => {
        this.#pauseTimer = null;
        this.#startAutoplay();
      }, ms);
    }

    #applySlots(skipTransition = false) {
      this.#centerWidth =
        this.#items[this.#index]?.offsetWidth || this.#centerWidth || 450;

      if (skipTransition) this.classList.add('is-instant');

      this.#items.forEach((item, i) => {
        this.#setSlot(item, i - this.#index, skipTransition);
      });

      if (skipTransition) {
        void this.offsetWidth;
        this.classList.remove('is-instant');
      }
    }

    #setSlot(item, offset, skipTransition) {
      const ratio = 231 / 450;
      const width = this.#centerWidth;
      const gap = (width * (1 + ratio)) / 2;
      const side = width * ratio;
      const abs = Math.abs(offset);

      let pos = 0;
      if (offset > 0) pos = gap + (offset - 1) * side;
      else if (offset < 0) pos = -(gap + (abs - 1) * side);

      const scale = offset === 0 ? 1 : ratio;

      if (skipTransition) item.classList.add('is-instant');

      item.dataset.slot = abs > 2 ? 'edge' : String(offset);
      item.classList.toggle('is-active', offset === 0);
      item.style.transform = `translate(calc(-50% + ${pos}px), -50%) scale(${scale})`;
      item.style.zIndex = offset === 0 ? 3 : Math.max(1, 3 - abs);

      if (skipTransition) {
        void item.offsetWidth;
        item.classList.remove('is-instant');
      }
    }

    #applyMeta() {
      const slideIndex = this.#index % this.#count;

      this.#titles.forEach((title, i) => {
        title.classList.toggle('is-active', i === slideIndex);
      });

      const active = this.#items[this.#index];
      if (!active || !this.#button) return;

      const url = active.dataset.buttonUrl;
      const label = active.dataset.buttonLabel;

      if (url) {
        this.#button.href = url;
      } else {
        this.#button.removeAttribute('href');
      }

      if (label && this.#buttonLabel) {
        this.#buttonLabel.textContent = label;
      }
    }

    #completeSlide() {
      if (!this.#busy) return;

      if (this.#index < this.#count) {
        this.#index += this.#count;
        this.#applySlots(true);
        this.#applyMeta();
      } else if (this.#index >= 2 * this.#count) {
        this.#index -= this.#count;
        this.#applySlots(true);
        this.#applyMeta();
      }

      this.#busy = false;
    }

    #slideTo(target) {
      if (this.#busy || this.#count <= 1 || target === this.#index) return;
      this.#busy = true;
      this.#stepToward(target);
    }

    #stepToward(target) {
      this.#index += target > this.#index ? 1 : -1;
      this.#applySlots(false);
      this.#applyMeta();

      const done =
        this.#index === target
          ? () => this.#completeSlide()
          : () => {
              if (!this.#busy) return;
              this.#stepToward(target);
            };

      const active = this.#items[this.#index];
      let called = false;
      const once = () => {
        if (called) return;
        called = true;
        done();
      };

      active?.addEventListener('transitionend', once, { once: true });
      window.setTimeout(once, 650);
    }

    #next() {
      this.#slideTo(this.#index + 1);
    }
  }

  if (!window.customElements.get('capsule-carousel')) {
    window.customElements.define('capsule-carousel', CapsuleCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('category-grid')) {
    /*
     * With a mouse, hovering a title reveals its image (pure CSS) and a click opens the collection.
     * On touch screens there is no hover: the first tap used to only reveal the image and a second tap
     * was needed to navigate, which nothing told the visitor. Now a tap always navigates, and the title
     * crossing the middle of the screen while scrolling becomes the active one, so its image shows up
     * without any tap. The media query matches the one the stylesheet uses for its touch rules.
     */
    class CategoryGrid extends HTMLElement {
      static touchQuery = '(pointer: fine)';

      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('.category-grid__link'));
        this.pointerQuery = window.matchMedia(CategoryGrid.touchQuery);
        this.onPointerChange = () => this.syncMode();

        this.links.forEach((link) => {
          link.addEventListener('click', (event) => {
            // The tapped title takes the highlight (and its image) right away, and keeps it while the
            // collection loads: the scroll tracking must not hand it back to the title in the middle.
            this.setActive(link);
            this.highlightLocked = true;

            // A tile without collection nor link would only reload the page: keep it as an image preview.
            // The lock only lasts until the next scroll, so the visitor gets the scroll behaviour back.
            if (!link.getAttribute('href')) {
              event.preventDefault();
              window.addEventListener('scroll', () => (this.highlightLocked = false), { once: true, passive: true });
              return;
            }

            // iOS browsers stop repainting the page as soon as a navigation starts, so the new highlight was
            // never shown and the title active before the tap stayed lit. On touch screens, the fades are
            // skipped so the title and its image switch at once, and the navigation waits for that paint.
            if (!this.observer || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target) return;
            event.preventDefault();
            this.classList.add('is-navigating');
            requestAnimationFrame(() => setTimeout(() => window.location.assign(link.href), 50));
          });
        });

        // Coming back from the collection with the back button restores this page from cache: hand the
        // highlight back to the scroll position.
        this.onPageShow = (event) => {
          if (!event.persisted) return;
          this.highlightLocked = false;
          this.classList.remove('is-navigating');
          if (this.observer) this.updateFromScroll();
        };
        window.addEventListener('pageshow', this.onPageShow);

        this.addEventListener('shopify:block:select', (event) => {
          const link = this.links.find((item) => item.dataset.blockId === event.detail.blockId);
          if (link) this.setActive(link);
        });

        this.pointerQuery.addEventListener('change', this.onPointerChange);
        this.syncMode();
      }

      disconnectedCallback() {
        this.pointerQuery?.removeEventListener('change', this.onPointerChange);
        window.removeEventListener('pageshow', this.onPageShow);
        this.stopScrollTracking();
      }

      syncMode() {
        const isTouch = !this.pointerQuery.matches;

        if (isTouch && !this.observer && this.links.length > 1) {
          this.startScrollTracking();
        } else if (!isTouch && this.observer) {
          this.stopScrollTracking();
          this.links.forEach((link) => link.classList.remove('is-active'));
        }
      }

      /*
       * The titles are only ~50px apart, so a thin detection band in the middle of the screen gets
       * skipped by fast or momentum scrolling. Instead, while the section is on screen, each scroll frame
       * picks the title closest to the middle of the viewport.
       */
      startScrollTracking() {
        this.frame = null;
        this.onScroll = () => {
          if (this.frame === null) this.frame = requestAnimationFrame(() => this.updateFromScroll());
        };

        this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            this.updateFromScroll();
          } else {
            window.removeEventListener('scroll', this.onScroll);
          }
        });
        this.observer.observe(this);
      }

      stopScrollTracking() {
        this.observer?.disconnect();
        this.observer = null;
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      updateFromScroll() {
        this.frame = null;
        if (this.highlightLocked) return;
        const middle = window.innerHeight / 2;
        let closest = null;
        let closestDistance = Infinity;

        this.links.forEach((link) => {
          const rect = link.getBoundingClientRect();
          const distance = Math.abs(rect.top + rect.height / 2 - middle);
          if (distance < closestDistance) {
            closest = link;
            closestDistance = distance;
          }
        });

        if (closest && !closest.classList.contains('is-active')) this.setActive(closest);
      }

      setActive(activeLink) {
        this.links.forEach((link) => link.classList.toggle('is-active', link === activeLink));
      }
    }

    window.customElements.define('category-grid', CategoryGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('collection-navigation')) {
    class CollectionNavigation extends HTMLElement {
      connectedCallback() {
        const active = this.querySelector('.is-active')?.closest('li');
        if (!active) return;

        const containerBleed = parseFloat(getComputedStyle(active.parentElement).marginLeft) || 0;

        active.parentElement.scrollTo({
          left: active.getBoundingClientRect().left + containerBleed,
          behavior: 'smooth'
        });
      }
    }

    window.customElements.define('collection-navigation', CollectionNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-carousel"] && !Shopify.designMode) return;
  try {
    
  class EditorialCarousel extends HTMLElement {
    #index = 0;
    #count = 0;
    #items = [];
    #button = null;
    #buttonLabel = null;
    #timer = null;
    #pauseTimer = null;
    #autoplaySeconds = 0;
    #busy = false;
    #centerWidth = 0;

    connectedCallback() {
      this.#count = Number(this.dataset.slideCount);
      this.#items = [...this.querySelectorAll('[js-item]')];
      this.#button = this.querySelector('[js-button]');
      this.#buttonLabel =
        this.#button?.querySelector('[js-button-content]') ?? this.#button;

      if (!this.#items.length) return;

      this.#index = this.#count > 1 ? this.#count : 0;
      this.#applySlots(true);
      this.#applyMeta();
      this.classList.add('is-ready');

      if (this.#count <= 1) return;

      this.#autoplaySeconds = Number(this.dataset.autoplay);
      if (this.#autoplaySeconds > 0) this.#startAutoplay();

      this.addEventListener('click', (event) => {
        const item = event.target.closest('[js-item]');
        if (!item) return;
        const target = this.#items.indexOf(item);
        if (target === -1 || target === this.#index) return;
        this.#slideTo(target);
        this.#pauseAutoplay();
      });

      this.addEventListener('shopify:block:select', (event) => {
        const index = this.#items.findIndex(
          (item) => item.dataset.blockId === event.detail.blockId,
        );
        if (index === -1) return;

        this.#index = index;
        this.#applySlots(event.detail.load);
        this.#applyMeta();
      });

      window.addEventListener('resize', () => this.#applySlots(true));
    }

    disconnectedCallback() {
      if (this.#timer) window.clearInterval(this.#timer);
      if (this.#pauseTimer) window.clearTimeout(this.#pauseTimer);
    }

    #startAutoplay() {
      this.#timer = window.setInterval(
        () => this.#next(),
        this.#autoplaySeconds * 1000,
      );
    }

    #pauseAutoplay(ms = 3000) {
      if (!this.#autoplaySeconds) return;
      if (this.#timer) window.clearInterval(this.#timer);
      this.#timer = null;
      if (this.#pauseTimer) window.clearTimeout(this.#pauseTimer);
      this.#pauseTimer = window.setTimeout(() => {
        this.#pauseTimer = null;
        this.#startAutoplay();
      }, ms);
    }

    #applySlots(skipTransition = false) {
      if (skipTransition) this.classList.add('is-instant');

      // Pass 1: set the active state first. The active slot uses the center
      // dimensions, so this must land before we measure its width — otherwise
      // (on mobile, where sides use a smaller explicit width) the center would
      // still report the side width and the slots would overlap.
      this.#items.forEach((item, i) => {
        item.classList.toggle('is-active', i === this.#index);
      });

      // Measure the (now correctly sized) center slot once. Only trust the
      // measurement on instant passes (load / settle), where widths have
      // snapped; during an animated slide the width is mid-transition, so
      // reuse the cached value to keep the gap stable.
      if (skipTransition) {
        this.#centerWidth = this.#items[this.#index]?.offsetWidth || this.#centerWidth;
      }
      const width = this.#centerWidth || this.#items[this.#index]?.offsetWidth || 462;
      const styles = window.getComputedStyle(this);
      const scale = parseFloat(styles.getPropertyValue('--ec-side-scale')) || 0.6;
      const gapRatio =
        parseFloat(styles.getPropertyValue('--ec-gap-ratio')) || 0.35;

      const gap = width * gapRatio;
      const firstOffset = (width * (1 + scale)) / 2 + gap;
      const sideStep = width * scale + gap;

      // Pass 2: position every slot.
      this.#items.forEach((item, i) => {
        const offset = i - this.#index;
        const abs = Math.abs(offset);

        let pos = 0;
        if (offset > 0) pos = firstOffset + (offset - 1) * sideStep;
        else if (offset < 0) pos = -(firstOffset + (abs - 1) * sideStep);

        item.style.setProperty('--ec-pos', `${pos}px`);
        item.style.zIndex = offset === 0 ? 3 : Math.max(1, 3 - abs);
      });

      if (skipTransition) {
        void this.offsetWidth;
        this.classList.remove('is-instant');
      }
    }

    #applyMeta() {
      const active = this.#items[this.#index];
      if (!active || !this.#button) return;

      const url = active.dataset.buttonUrl;
      const label = active.dataset.buttonLabel;

      if (url) {
        this.#button.href = url;
      } else {
        this.#button.removeAttribute('href');
      }

      if (label && this.#buttonLabel) {
        this.#buttonLabel.textContent = label;
      }
    }

    #completeSlide() {
      if (!this.#busy) return;

      if (this.#index < this.#count) {
        this.#index += this.#count;
        this.#applySlots(true);
        this.#applyMeta();
      } else if (this.#index >= 2 * this.#count) {
        this.#index -= this.#count;
        this.#applySlots(true);
        this.#applyMeta();
      }

      this.#busy = false;
    }

    #slideTo(target) {
      if (this.#busy || this.#count <= 1 || target === this.#index) return;
      this.#busy = true;
      this.#stepToward(target);
    }

    #stepToward(target) {
      this.#index += target > this.#index ? 1 : -1;
      this.#applySlots(false);
      this.#applyMeta();

      const done =
        this.#index === target
          ? () => this.#completeSlide()
          : () => {
              if (!this.#busy) return;
              this.#stepToward(target);
            };

      const active = this.#items[this.#index];
      let called = false;
      const once = () => {
        if (called) return;
        called = true;
        done();
      };

      active?.addEventListener('transitionend', once, { once: true });
      window.setTimeout(once, 650);
    }

    #next() {
      this.#slideTo(this.#index + 1);
    }
  }

  if (!window.customElements.get('editorial-carousel')) {
    window.customElements.define('editorial-carousel', EditorialCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-section')) {
      return;
    }

    class HeroSection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.wireCardLink();
        this.initCardAlignment();

        if (
          !this.hasAttribute('scroll-animate') ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          return;
        }

        this.initElements();
        this.attachEvents();
        this.update();
      }

      initCardAlignment() {
        this.cardAlignMedia = window.matchMedia('(min-width: 1000px)');
        this.alignCard = this.alignCard.bind(this);

        const scheduleAlign = () => requestAnimationFrame(this.alignCard);
        this.cardAlignObserver = new ResizeObserver(scheduleAlign);
        const inner = this.querySelector('.hero__content-inner');
        const card = this.querySelector('.hero__product-card');
        if (inner) this.cardAlignObserver.observe(inner);
        if (card) this.cardAlignObserver.observe(card);

        this.cardAlignMediaListener = scheduleAlign;
        this.cardAlignMedia.addEventListener(
          'change',
          this.cardAlignMediaListener,
        );
        window.addEventListener('load', scheduleAlign);
        this.alignCard();
      }

      alignCard() {
        const card = this.querySelector('.hero__product-card');
        const anchor =
          this.querySelector('.hero__content-inner .button') ||
          this.querySelector('.hero__content-inner');
        if (!card || !anchor) return;

        if (!this.cardAlignMedia.matches) {
          card.style.removeProperty('--hero-card-align-shift');
          card.removeAttribute('data-align-ready');
          return;
        }

        const anchorRect = anchor.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const currentShift =
          parseFloat(card.style.getPropertyValue('--hero-card-align-shift')) ||
          0;
        const anchorCenter = anchorRect.top + anchorRect.height / 2;
        const cardCenter = cardRect.top + cardRect.height / 2;
        const shift = currentShift + (anchorCenter - cardCenter);

        if (Math.abs(shift - currentShift) >= 0.5) {
          card.style.setProperty('--hero-card-align-shift', `${shift}px`);
        }
        card.setAttribute('data-align-ready', '');
      }

      wireCardLink() {
        const box = this.querySelector('.hero__box');
        if (!box || box.querySelector('.hero__card-link')) return;

        const button = this.querySelector('.hero__content .button[href]');
        if (!button) return;

        const href = button.getAttribute('href');
        if (!href || href === '#') return;

        const link = document.createElement('a');
        link.className = 'hero__card-link';
        link.href = href;
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
        if (button.target) {
          link.target = button.target;
          if (button.rel) link.rel = button.rel;
        }

        const media = box.querySelector('.hero__media');
        if (media && media.nextSibling) {
          box.insertBefore(link, media.nextSibling);
        } else {
          box.appendChild(link);
        }
      }

      disconnectedCallback() {
        this.detachEvents();

        if (this.cardAlignObserver) {
          this.cardAlignObserver.disconnect();
          this.cardAlignObserver = null;
        }
        if (this.cardAlignMedia && this.cardAlignMediaListener) {
          this.cardAlignMedia.removeEventListener(
            'change',
            this.cardAlignMediaListener,
          );
        }
      }

      initElements() {
        this.frame = this.querySelector('.hero__inner');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.updateScrollRange();
      }

      updateScrollRange() {
        this.scrollRange = window.innerHeight * 0.1;
      }

      attachEvents() {
        this.onScroll = this.update.bind(this);
        this.onResize = this.debounce(() => {
          this.updateScrollRange();
          this.update();
        }, 200);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
      }

      detachEvents() {
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
        }

        if (this.onResize) {
          window.removeEventListener('resize', this.onResize);
        }
      }

      getSpacing() {
        const isMobile = this.mobileQuery.matches;
        const prefix = isMobile ? 'mobile' : 'desktop';

        return {
          left: Number(this.dataset[prefix + 'Left'] ?? 0),
          right: Number(this.dataset[prefix + 'Right'] ?? 0),
          top: isMobile ? Number(this.dataset[prefix + 'Top'] ?? 0) : 40,
          bottom: Number(this.dataset[prefix + 'Bottom'] ?? 0),
        };
      }

      update() {
        if (!this.frame) {
          return;
        }

        const { left, right, top, bottom } = this.getSpacing();
        const progress = Math.min(window.scrollY / this.scrollRange, 1);
        const invertedProgress = 1 - progress;

        this.frame.style.paddingTop = `${top * invertedProgress}px`;
        this.frame.style.paddingBottom = `${bottom * invertedProgress}px`;
        this.frame.style.paddingLeft = `${left * invertedProgress}px`;
        this.frame.style.paddingRight = `${right * invertedProgress}px`;
      }

      debounce(fn, wait) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }

    customElements.define('hero-section', HeroSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    if (!customElements.get('read-more-text')) {
      customElements.define(
        'read-more-text',
        class extends HTMLElement {
          connectedCallback() {
            this.content = this.querySelector('.read-more__content');
            this.toggle = this.querySelector('.read-more__toggle');

            if (!this.content || !this.toggle) {
              return;
            }

            this.moreLabel = this.toggle.querySelector('[data-more]');
            this.lessLabel = this.toggle.querySelector('[data-less]');

            requestAnimationFrame(() => this.updateOverflow());
            this.resizeObserver = new ResizeObserver(() =>
              this.updateOverflow(),
            );
            this.resizeObserver.observe(this.content);

            this.toggle.addEventListener('click', () => {
              if (this.hasAttribute('data-scroll-to-description-tab')) {
                this.scrollToDescriptionTab();
              } else {
                this.toggleExpanded();
              }
            });
          }

          scrollToDescriptionTab() {
            const target = document.querySelector('.js-description-target');
            if (!target) {
              this.toggleExpanded();
              return;
            }

            const details = target.querySelector('details');
            if (details && !details.open) {
              details.open = true;
            }

            const headerOffset =
              parseInt(
                getComputedStyle(document.documentElement).getPropertyValue(
                  '--header-height',
                ),
              ) || 0;
            const rect = target.getBoundingClientRect();
            const scrollTop = window.scrollY + rect.top - headerOffset - 16;
            window.scrollTo({ top: scrollTop, behavior: 'smooth' });
          }

          disconnectedCallback() {
            if (this.resizeObserver) {
              this.resizeObserver.disconnect();
            }
          }

          updateOverflow() {
            if (this.hasAttribute('data-expanded')) {
              return;
            }

            const overflows =
              this.content.scrollHeight > this.content.clientHeight + 1;

            // The intro excerpt can fit without overflowing while the full description is in the tab
            this.toggle.hidden = !overflows && !this.hasAttribute('data-has-more');
          }

          toggleExpanded() {
            if (this.hasAttribute('data-expanded')) {
              this.collapse();
            } else {
              this.expand();
            }
          }

          expand() {
            this.style.setProperty(
              '--read-more-full-height',
              this.content.scrollHeight + 'px',
            );
            this.setAttribute('data-expanded', '');
            this.setLabels(true);

            this.content.addEventListener(
              'transitionend',
              () => {
                if (this.hasAttribute('data-expanded')) {
                  this.style.setProperty('--read-more-full-height', 'none');
                }
              },
              { once: true },
            );
          }

          collapse() {
            this.style.setProperty(
              '--read-more-full-height',
              this.content.scrollHeight + 'px',
            );

            requestAnimationFrame(() => {
              this.removeAttribute('data-expanded');
              this.setLabels(false);
            });
          }

          setLabels(expanded) {
            if (this.moreLabel) {
              this.moreLabel.hidden = expanded;
            }

            if (this.lessLabel) {
              this.lessLabel.hidden = !expanded;
            }
          }
        },
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare"]) return;
  try {
    
  (() => {
    if (customElements.get('product-compare')) return;

    const STORAGE_KEY = 'delsey:product-compare';
    const CHANGE_EVENT = 'product-compare:change';
    const LIMIT_EVENT = 'product-compare:limit';
    const GROUP_EVENT = 'product-compare:group';
    const COLLAPSED_KEY = 'delsey:product-compare-collapsed';
    let memoryItems = [];

    // Sélection partagée entre les cases des cartes et la barre. localStorage peut être
    // indisponible (navigation privée, stockage bloqué) : on retombe alors sur la mémoire.
    const store = {
      max: 3,

      read() {
        try {
          const items = JSON.parse(localStorage.getItem(STORAGE_KEY));
          return Array.isArray(items) ? items : [];
        } catch (error) {
          return memoryItems;
        }
      },

      write(items) {
        memoryItems = items;
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        } catch (error) {}
        document.dispatchEvent(new CustomEvent(CHANGE_EVENT));
      },

      has(handle) {
        return this.read().some((item) => item.handle === handle);
      },

      // Valises et sacs n'ont pas le même tableau TableFlow : une comparaison ne mélange pas les deux
      // familles. Les sélections gardées avant l'arrivée des sacs n'ont pas de famille : des valises.
      add(item) {
        const items = this.read().filter((entry) => entry.handle !== item.handle);
        if (items.some((entry) => (entry.group || 'suitcase') !== item.group)) {
          document.dispatchEvent(new CustomEvent(GROUP_EVENT));
          return false;
        }
        if (items.length >= this.max) {
          document.dispatchEvent(new CustomEvent(LIMIT_EVENT));
          return false;
        }
        this.write([...items, item]);
        return true;
      },

      remove(handle) {
        this.write(this.read().filter((item) => item.handle !== handle));
      },

      clear() {
        this.write([]);
      },
    };

    // Autre onglet : la sélection a changé, on resynchronise cases et barre.
    window.addEventListener('storage', (event) => {
      if (event.key === STORAGE_KEY) document.dispatchEvent(new CustomEvent(CHANGE_EVENT));
    });

    // Le comparateur n'existe que si l'app embed « Compare » de TableFlow est active : elle
    // pose ses réglages de design dans #tfc-design-settings, sans lesquels l'app se désactive.
    const isAvailable = () => Boolean(document.getElementById('tfc-design-settings'));

    const whenParsed = (callback) => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    };

    class ProductCompareToggle extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="checkbox"]');
        if (!this.input) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        whenParsed(() => {
          this.hidden = !isAvailable();
        });

        this.sync();
        this.input.addEventListener('change', () => this.onChange(), { signal });
        document.addEventListener(CHANGE_EVENT, () => this.sync(), { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      sync() {
        this.input.checked = store.has(this.dataset.handle);
      }

      onChange() {
        if (!this.input.checked) {
          store.remove(this.dataset.handle);
          return;
        }

        const added = store.add({
          handle: this.dataset.handle,
          group: this.dataset.compareGroup || 'suitcase',
          title: this.dataset.title || '',
          subtitle: this.dataset.subtitle || '',
          image: this.dataset.image || '',
        });

        if (!added) this.input.checked = false;
      }
    }

    class ProductCompare extends HTMLElement {
      connectedCallback() {
        store.max = parseInt(this.dataset.max, 10) || store.max;

        this.bar = this.querySelector('[data-compare-bar]');
        this.list = this.querySelector('[data-compare-list]');
        this.openButton = this.querySelector('[data-compare-open]');
        this.hint = this.querySelector('[data-compare-hint]');
        this.content = this.querySelector('[data-compare-content]');
        this.collapseButton = this.querySelector('[data-compare-collapse]');
        this.tabCount = this.querySelector('[data-compare-tab-count]');
        this.modal = this.querySelector('#product-compare-modal');
        this.tableContainer = this.querySelector('[data-compare-table]');
        this.highlightSwitch = this.querySelector('[data-compare-highlight]');
        this.pager = this.querySelector('[data-compare-pager]');
        this.renderedSelection = null;
        this.style.setProperty('--compare-max', store.max);

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.querySelector('[data-compare-clear]').addEventListener('click', () => store.clear(), { signal });
        this.collapseButton.addEventListener('click', () => this.setCollapsed(!this.content.hidden, true), { signal });
        this.list.addEventListener('click', (event) => this.onListClick(event), { signal });
        this.tableContainer.addEventListener('click', (event) => this.onListClick(event), { signal });
        this.highlightSwitch.addEventListener('change', () => this.onHighlightChange(), { signal });
        this.modal.addEventListener('dialog:before-show', () => this.mountTable(), { signal });
        document.addEventListener(CHANGE_EVENT, () => this.render(), { signal });
        document.addEventListener(
          LIMIT_EVENT,
          () => {
            // Barre repliée : on la rouvre pour que le message de limite soit lisible.
            this.setCollapsed(false, true);
            this.showHint(this.dataset.labelMax);
          },
          { signal }
        );
        document.addEventListener(
          GROUP_EVENT,
          () => {
            this.setCollapsed(false, true);
            this.showHint(this.dataset.labelGroup);
          },
          { signal }
        );

        let collapsed = false;
        try {
          collapsed = localStorage.getItem(COLLAPSED_KEY) === '1';
        } catch (error) {}
        this.setCollapsed(collapsed, false);

        whenParsed(() => {
          this.available = isAvailable();
          this.render();
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.labelObserver?.disconnect();
      }

      render() {
        const items = store.read();
        this.bar.hidden = !this.available || items.length === 0 || this.hasAttribute('data-bar-disabled');

        // Une case par produit possible, les libres en « + Ajouter ».
        const slots = Array.from({ length: Math.max(store.max - items.length, 0) }, () => this.renderEmptySlot());
        this.list.replaceChildren(...items.map((item) => this.renderItem(item)), ...slots);
        this.tabCount.textContent = `· ${items.length}/${store.max}`;
        this.openButton.disabled = items.length < 2;
        this.openButton.textContent =
          items.length < 2 ? this.dataset.labelAddMore : this.dataset.labelOpen.replace('[count]', items.length);
        this.showHint('');

        // Produit retiré depuis la modale : on remonte le tableau, ou on la ferme s'il n'y a plus de
        // comparaison possible.
        if (this.modal.open) {
          if (items.length < 2) {
            this.modal.hide();
          } else {
            this.mountTable();
          }
        }
      }

      renderEmptySlot() {
        const li = document.createElement('li');
        li.className = 'product-compare-bar__item product-compare-bar__item--empty';
        li.setAttribute('aria-hidden', 'true');
        li.textContent = `+ ${this.dataset.labelAdd}`;
        return li;
      }

      renderItem(item) {
        const li = document.createElement('li');
        li.className = 'product-compare-bar__item';

        const image = document.createElement('img');
        image.className = 'product-compare-bar__item-image';
        image.width = 55;
        image.height = 55;
        image.alt = '';
        image.loading = 'lazy';
        if (item.image) image.src = item.image;

        const title = document.createElement('span');
        title.className = 'product-compare-bar__item-title';
        title.textContent = item.title;
        if (item.subtitle) {
          const subtitle = document.createElement('small');
          subtitle.textContent = item.subtitle;
          title.append(subtitle);
        }

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'product-compare-bar__remove';
        remove.dataset.compareRemove = item.handle;
        remove.setAttribute('aria-label', `${this.dataset.labelRemove} ${item.title}`.trim());
        remove.innerHTML =
          '<svg viewBox="0 0 10 10" aria-hidden="true" fill="none"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5"/></svg>';

        li.append(image, title, remove);
        return li;
      }

      onListClick(event) {
        const button = event.target.closest('[data-compare-remove]');
        if (button) store.remove(button.dataset.compareRemove);
      }

      // Barre repliée à l'onglet seul. Le choix est gardé d'une page à l'autre.
      setCollapsed(collapsed, remember) {
        this.content.hidden = collapsed;
        this.bar.toggleAttribute('data-collapsed', collapsed);
        this.collapseButton.setAttribute('aria-expanded', String(!collapsed));
        if (!remember) return;
        try {
          if (collapsed) {
            localStorage.setItem(COLLAPSED_KEY, '1');
          } else {
            localStorage.removeItem(COLLAPSED_KEY);
          }
        } catch (error) {}
      }

      // L'interrupteur mobile pilote la case de l'app, qui pose elle-même le surlignage.
      onHighlightChange() {
        const appToggle = this.tableContainer.querySelector('.tfv1-compare-highlight-toggle');
        if (appToggle && appToggle.checked !== this.highlightSwitch.checked) appToggle.click();
      }

      // Tirets du défilement mobile : un par produit, plein quand sa colonne est visible à moitié
      // au moins. Rien quand tout tient à l'écran.
      updatePager(wrapper) {
        const cells = [...wrapper.querySelectorAll('.tfv1-compare-header-row-image .tfv1-compare-product-col')];
        const label = wrapper.querySelector('.tfv1-compare-header-row-image .tfv1-compare-label-col');
        const view = wrapper.getBoundingClientRect();
        const start = label ? label.getBoundingClientRect().right : view.left;

        const dashes = cells.map((cell) => {
          const rect = cell.getBoundingClientRect();
          const visible = Math.min(rect.right, view.right) - Math.max(rect.left, start);
          const dash = document.createElement('span');
          if (visible >= rect.width / 2) dash.dataset.visible = '';
          return dash;
        });

        const allVisible = dashes.every((dash) => dash.hasAttribute('data-visible'));
        this.pager.replaceChildren(...(allVisible ? [] : dashes));
      }

      showHint(message) {
        this.hint.textContent = message || '';
        clearTimeout(this.hintTimer);
        if (message && (message === this.dataset.labelMax || message === this.dataset.labelGroup)) {
          this.hintTimer = setTimeout(() => this.showHint(''), 4000);
        }
      }

      // Le composant de l'app lit ses attributs une seule fois : on en monte un neuf à chaque
      // changement de sélection, et on garde le précédent tant qu'elle ne bouge pas (l'app a
      // déjà récupéré les fiches produit).
      mountTable() {
        const selection = store
          .read()
          .map((item) => item.handle)
          .join(',');
        if (selection === this.renderedSelection) return;
        this.renderedSelection = selection;

        const table = document.createElement('tableflow-compare');
        table.setAttribute('compareProducts', selection);
        // Le prix d'en-tête de l'app est formaté en dollars en dur ; le tableau porte déjà
        // une ligne Prix dans la devise de la boutique.
        table.setAttribute('showPrice', 'false');

        this.labelObserver?.disconnect();
        this.tableContainer.replaceChildren(table);
        this.observeTable(table);
      }

      // Retouches à chaque rendu de l'app :
      // - ligne Features : pictos appariés à leurs libellés ;
      // - ses libellés sont en anglais (codés en dur ou saisis une fois pour toutes les langues
      //   dans l'admin TableFlow) : on les remplace par ceux du thème ;
      // - ses images d'en-tête pointent sur l'original (3000 px) pour un affichage à 120 px ;
      // - elle lit l'image d'en-tête dans le JSON-LD de la fiche, en supposant une liste : sur les
      //   produits à une variante, Shopify y écrit une simple URL et l'app n'en garde que le premier
      //   caractère (« h »). On reprend alors la vignette de la sélection.
      observeTable(table) {
        const images = new Map(store.read().map((item) => [item.handle, item.image]));

        const labels = [
          ['.tfv1-compare-header-row-button .tfv1-compare-label-col span', this.dataset.labelSpecification],
          ['.tfv1-compare-view-btn', this.dataset.labelViewProduct],
          ['.tfv1-compare-highlight-option span', this.dataset.labelHighlight],
          ['.tfv1-compare-loading span', this.dataset.labelLoading],
        ];
        const shortViewLabel = this.dataset.labelViewProductShort || this.dataset.labelViewProduct;

        const adapt = () => {
          labels.forEach(([selector, label]) => {
            if (!label) return;
            table.querySelectorAll(selector).forEach((element) => {
              if (element.textContent !== label) element.textContent = label;
            });
          });

          // Bouton « Voir » du mobile (cf. CSS) : libellé court affiché, nom du produit lu.
          table.querySelectorAll('.tfv1-compare-view-btn:not([data-label-short])').forEach((button) => {
            button.dataset.labelShort = shortViewLabel;
          });

          const appToggle = table.querySelector('.tfv1-compare-highlight-toggle');
          if (appToggle) this.highlightSwitch.checked = appToggle.checked;

          const wrapper = table.querySelector('.tfv1-compare-table-wrapper');
          if (wrapper && !wrapper.hasAttribute('data-compare-pager-bound')) {
            wrapper.setAttribute('data-compare-pager-bound', '');
            wrapper.addEventListener('scroll', () => this.updatePager(wrapper), { passive: true });
          }

          // Ligne Features : chaque picto regroupé avec le libellé de même rang, dans une liste qui
          // remplace le contenu de la cellule (cf. le CSS de la ligne Features).
          table.querySelectorAll('td.tfv1-data').forEach((cell) => {
            const icons = cell.querySelectorAll(':scope > .tfv1-metafield-list > img.metafield-file_reference');
            if (!icons.length) return;
            const texts = cell.querySelectorAll(':scope > .tfv1-metafield-list > span');

            const list = document.createElement('ul');
            list.className = 'product-compare-features unstyled-list';
            list.setAttribute('role', 'list');
            icons.forEach((icon, index) => {
              const item = document.createElement('li');
              item.className = 'product-compare-features__item';
              item.append(icon);
              if (texts[index]) item.append(texts[index]);
              list.append(item);
            });
            cell.replaceChildren(list);
          });

          const buttonCells = table.querySelectorAll('.tfv1-compare-header-row-button .tfv1-compare-product-col');
          table.querySelectorAll('.tfv1-compare-header-row-image .tfv1-compare-product-col').forEach((cell, index) => {
            const href = buttonCells[index]?.querySelector('.tfv1-compare-view-btn')?.getAttribute('href') || '';
            const handle = decodeURIComponent(href.split('/products/')[1]?.split(/[?#]/)[0] || '');

            // Retrait du produit depuis la modale (mobile, cf. CSS).
            const wrapper = cell.querySelector('.tfv1-compare-img-wrapper');
            if (handle && wrapper && !wrapper.querySelector('[data-compare-remove]')) {
              const title = store.read().find((item) => item.handle === handle)?.title || '';
              const remove = document.createElement('button');
              remove.type = 'button';
              remove.className = 'product-compare-modal__remove';
              remove.dataset.compareRemove = handle;
              remove.setAttribute('aria-label', `${this.dataset.labelRemove} ${title}`.trim());
              remove.innerHTML =
                '<svg viewBox="0 0 10 10" aria-hidden="true" fill="none"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5"/></svg>';
              wrapper.append(remove);
            }

            const image = cell.querySelector('img.tfv1-compare-product-img');
            if (!image) return;
            let src = image.getAttribute('src') || '';

            if (!/^(https?:)?\/\/|^\//.test(src)) {
              const fallback = handle && images.get(handle);
              if (!fallback) return;
              src = fallback.replace(/([?&]width=)\d+/, '$1240');
              image.setAttribute('src', src);
            }

            if (!src.includes('/cdn/shop/') && !src.includes('cdn.shopify.com')) return;
            if (/[?&]width=/.test(src)) return;
            image.setAttribute('src', `${src}${src.includes('?') ? '&' : '?'}width=240`);
          });

          if (wrapper) this.updatePager(wrapper);
        };

        this.labelObserver = new MutationObserver(adapt);
        this.labelObserver.observe(table, { childList: true, subtree: true });
        adapt();
      }
    }

    customElements.define('product-compare-toggle', ProductCompareToggle);
    customElements.define('product-compare', ProductCompare);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["push-category"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('slider-categories')) return;

    class SliderCategories extends HTMLElement {
      static cardSelector = '.category__card';
      static itemSelector = '.category__item';
      static sliderSelector = '.categories__slider';
      static positionClasses = ['is-prev', 'is-next', 'is-before', 'is-after'];
      static mobileBreakpoint = 1299;

      constructor() {
        super();

        this.flickity = null;
        this.pendingFrame = null;
        this.appliedShifts = new WeakMap();
        this.onResize = this.debounce(() => this.syncToViewport(), 200);
      }

      connectedCallback() {
        this.syncToViewport();

        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);

        this.destroySlider();
      }

      syncToViewport() {
        const blockCount = parseInt(this.dataset.blockCount);

        if (blockCount <= 1) {
          return;
        }

        const isMobile = window.innerWidth <= SliderCategories.mobileBreakpoint;

        if (isMobile && !this.flickity) {
          this.createSlider();
        } else if (!isMobile && this.flickity) {
          this.destroySlider();
        }
      }

      createSlider() {
        if (typeof Flickity === 'undefined') {
          window.addEventListener('load', () => this.syncToViewport(), { once: true });

          return;
        }

        this.flickity = new Flickity(this.querySelector(SliderCategories.sliderSelector), {
          cellAlign: 'center',
          contain: false,
          draggable: true,
          wrapAround: true,
          pageDots: false,
          prevNextButtons: false,
          initialIndex: parseInt(this.dataset.initialIndex, 10),
        });

        this.measureStaticLayout();

        this.flickity.on('resize', () => {
          this.measureStaticLayout();

          this.render();
        });

        this.flickity.on('scroll', () => this.scheduleRender());

        this.flickity.on('settle', () => {
          if (this.pendingFrame !== null) {
            cancelAnimationFrame(this.pendingFrame);

            this.pendingFrame = null;
          }

          this.render();
        });

        this.render();
      }

      destroySlider() {
        if (this.pendingFrame !== null) {
          cancelAnimationFrame(this.pendingFrame);

          this.pendingFrame = null;
        }

        if (this.flickity) {
          this.flickity.destroy();

          this.flickity = null;
        }

        this.clearComputedStyles();
      }

      clearComputedStyles() {
        this.querySelectorAll(SliderCategories.itemSelector).forEach((item) => {
          item.style.left = '';
          item.classList.remove(...SliderCategories.positionClasses);

          const card = item.querySelector(SliderCategories.cardSelector);

          if (card) {
            card.style.transform = '';
          }
        });

        this.appliedShifts = new WeakMap();
      }

      scheduleRender() {
        if (this.pendingFrame !== null) {
          return;
        }

        this.pendingFrame = requestAnimationFrame(() => {
          this.pendingFrame = null;

          this.render();
        });
      }

      measureStaticLayout() {
        const rootStyles = getComputedStyle(this);
        const readNumber = (customProperty, fallback) => {
          const value = parseFloat(rootStyles.getPropertyValue(customProperty));

          return Number.isFinite(value) ? value : fallback;
        };

        this.config = {
          scaleMin: readNumber('--category-scale-min', 0.52),
          scaleMax: readNumber('--category-scale-max', 1),
          falloff: readNumber('--category-scale-falloff', 2),
        };

        this.flickity.cells.forEach((cell) => {
          cell.element.style.left = '';
        });

        this.appliedShifts = new WeakMap();

        this.itemMetrics = this.flickity.cells.map((cell) => {
          const element = cell.element;
          const rect = element.getBoundingClientRect();
          const itemStyles = getComputedStyle(element);
          const horizontalMargin = parseFloat(itemStyles.marginLeft) + parseFloat(itemStyles.marginRight);

          return { width: rect.width, horizontalMargin };
        });
      }

      render() {
        if (!this.flickity) {
          return;
        }

        const { scaleMin, scaleMax, falloff } = this.config;
        const containerRect = this.getBoundingClientRect();
        const containerCenter = containerRect.left + containerRect.width / 2;

        const items = this.flickity.cells.map((cell, index) => {
          const element = cell.element;
          const rect = element.getBoundingClientRect();
          const appliedShift = this.appliedShifts.get(element) || 0;
          const center = rect.left + rect.width / 2 - appliedShift;
          const offset = center - containerCenter;
          const { width, horizontalMargin } = this.itemMetrics[index];

          return { element, offset, width, horizontalMargin };
        });

        items.sort((first, second) => first.offset - second.offset);

        const fadeDistance = (items[0] ? items[0].width : 0) * falloff || 1;

        items.forEach((item) => {
          const distanceRatio = Math.min(Math.abs(item.offset) / fadeDistance, 1);

          item.scale = scaleMax - (scaleMax - scaleMin) * distanceRatio;
        });

        const centeredIndex = items.reduce(
          (closest, item, index) =>
            Math.abs(item.offset) < Math.abs(items[closest].offset) ? index : closest,
          0,
        );

        this.applyScaleAndClasses(items, centeredIndex);
        this.applyPositions(items);
      }

      applyScaleAndClasses(items, centeredIndex) {
        items.forEach((item, index) => {
          item.element.querySelector(SliderCategories.cardSelector).style.transform = `scale(${item.scale})`;
          item.element.classList.remove(...SliderCategories.positionClasses);

          if (index < centeredIndex) {
            item.element.classList.add('is-before');

            if (index === centeredIndex - 1) {
              item.element.classList.add('is-prev');
            }
          } else if (index > centeredIndex) {
            item.element.classList.add('is-after');

            if (index === centeredIndex + 1) {
              item.element.classList.add('is-next');
            }
          }
        });
      }

      applyPositions(items) {
        const gapBetween = (left, right) =>
          (left.width * left.scale) / 2 +
          (right.width * right.scale) / 2 +
          left.horizontalMargin / 2 +
          right.horizontalMargin / 2;

        const chainPositions = new Array(items.length);

        chainPositions[0] = 0;

        for (let index = 1; index < items.length; index++) {
          chainPositions[index] =
            chainPositions[index - 1] + gapBetween(items[index - 1], items[index]);
        }

        const anchor = this.anchorAtCenter(items, chainPositions);

        items.forEach((item, index) => {
          const shift = chainPositions[index] - anchor - item.offset;

          item.element.style.left = `${shift}px`;

          this.appliedShifts.set(item.element, shift);
        });
      }

      anchorAtCenter(items, chainPositions) {
        let lowerIndex = null;
        let upperIndex = null;

        for (let index = 0; index < items.length; index++) {
          if (items[index].offset <= 0) {
            lowerIndex = index;
          }

          if (items[index].offset >= 0 && upperIndex === null) {
            upperIndex = index;
          }
        }

        if (lowerIndex !== null && upperIndex !== null && lowerIndex !== upperIndex) {
          const lowerOffset = items[lowerIndex].offset;
          const upperOffset = items[upperIndex].offset;
          const ratio = (0 - lowerOffset) / (upperOffset - lowerOffset);

          return (
            chainPositions[lowerIndex] +
            ratio * (chainPositions[upperIndex] - chainPositions[lowerIndex])
          );
        }

        const nearestIndex = lowerIndex !== null ? lowerIndex : upperIndex;

        return chainPositions[nearestIndex] - items[nearestIndex].offset;
      }

      debounce(fn, wait) {
        let timer;

        return (...args) => {
          clearTimeout(timer);

          timer = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }

    customElements.define('slider-categories', SliderCategories);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-stories"] && !Shopify.designMode) return;
  try {
    
  /*
   * Le dimensionnement des cartes est entièrement en CSS (variables lues par le
   * widget Join, voir la feuille de style). Le JS se limite à :
   *  - attendre le montage du widget (shadow DOM asynchrone, aucun événement émis),
   *  - masquer ses flèches natives et brancher celles du thème sur sa liste,
   *  - tenir le compteur et l'état des flèches à jour,
   *  - fournir la largeur du wrapper aux navigateurs sans unités de container query,
   *  - neutraliser le chargement paresseux de Join : cartes révélées sans condition et
   *    covers vidéo qui affichent leur première image (voir primeUgcStoriesCovers).
   */
  const UGC_STORIES_POLL_INTERVAL = 200;
  const UGC_STORIES_POLL_TIMEOUT = 120000;
  const UGC_STORIES_SUPPORTS_CQW = typeof CSS !== 'undefined' && CSS.supports('width', '1cqw');

  /*
   * Les styles de la section n'atteignent pas le shadow DOM du widget : on y
   * injecte une feuille dédiée. Rien de structurel ici, le placement des cartes
   * reste piloté par les variables CSS de l'hôte.
   */
  function injectUgcStoriesShadowStyle(shadowRoot) {
    if (shadowRoot.querySelector('[js-ugc-stories-shadow-style]')) return;

    const style = document.createElement('style');
    style.setAttribute('js-ugc-stories-shadow-style', '');
    style.textContent = [
      // Flèches natives : ce sont celles du thème qui pilotent la liste.
      '.join-carousel-button { display: none !important; }',
      // Titre optionnel du widget : la section a son propre heading.
      '.join-list-title { display: none !important; }',
      // Liste toujours calée à gauche (Join la centre quand elle ne déborde pas) et
      // cartes accrochées au bord au défilement, comme les tuiles de la section "UGC".
      // La dernière s'accroche par sa fin : la position de fin de liste est un vrai
      // point d'accroche, la dernière carte est donc toujours atteignable en entier.
      '.join-widget-list { margin-inline: 0 !important; scroll-snap-type: x mandatory; scroll-padding-inline: 10px; }',
      '.join-widget-element { scroll-snap-align: start; }',
      '.join-widget-element:last-child { scroll-snap-align: end; }',
      // Cartes toujours visibles. Join les garde à opacity 0 tant que sa liste n'a pas la
      // classe .visible, qu'il ne pose qu'en recevant exactement son seuil de visibilité
      // de 10 % : quand la section entre d'un bloc dans l'écran (grand viewport, ancre,
      // défilement rapide) le seuil est sauté et les cartes restent invisibles. Les
      // animations d'apparition qui en dépendent tombent avec. Le sélecteur est plus
      // spécifique que le `li:nth-child(1) .join-widget-element !important` de Join.
      '.join-widget-list li.join-widget-element[data-story-id], .join-widget-list li.join-widget-element.join-card-shape { opacity: 1 !important; animation: none !important; }',
    ].join('\n');
    shadowRoot.append(style);
  }

  /*
   * Chargement paresseux de Join, côté médias. Ses vignettes sont en loading="lazy" ;
   * et quand une vignette manque (data-thumbnail-error, le cas des stories dont Join n'a
   * pas produit de rendition), la carte n'a plus que sa <video> en preload="metadata" :
   * le navigateur ne peint aucune image tant qu'elle n'a pas joué, et Join ne lance ses
   * covers qu'au compte-gouttes (une à la fois sur desktop) — carte vide. Un seek de
   * quelques centièmes après les métadonnées décode et affiche la première image, sans
   * lecture ni téléchargement complet. Idempotent : rejoué à chaque re-render de Join.
   */
  function primeUgcStoriesCovers(shadowRoot) {
    shadowRoot.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
    });

    shadowRoot
      .querySelectorAll('video.video-cover[data-thumbnail-error]:not([js-ugc-stories-primed])')
      .forEach((video) => {
        video.setAttribute('js-ugc-stories-primed', '');

        const showFirstFrame = () => {
          if (!video.paused || video.currentTime > 0) return;
          try {
            video.currentTime = 0.05;
          } catch (error) {
            // Métadonnées pas encore exploitables : Join relancera un render, on repassera.
          }
        };

        if (video.readyState >= HTMLMediaElement.HAVE_METADATA) showFirstFrame();
        else video.addEventListener('loadedmetadata', showFirstFrame, { once: true });
      });
  }

  function initUgcStories(section) {
    const host = section.querySelector('[js-ugc-stories-widget]');
    if (!host || section.dataset.ugcStoriesInit) return;

    section.dataset.ugcStoriesInit = 'true';

    const wrapper = section.querySelector('[js-ugc-stories-wrapper]');
    const controls = section.querySelector('[js-ugc-stories-controls]');
    const prevButton = controls?.querySelector('[js-ugc-stories-prev]');
    const nextButton = controls?.querySelector('[js-ugc-stories-next]');
    const currentSlideEl = controls?.querySelector('[js-ugc-stories-current]');
    const totalEl = controls?.querySelector('[js-ugc-stories-total]');

    // Join peut recréer sa liste (changement de plateforme, rechargement des
    // stories) : on la re-cherche à chaque fois plutôt que de la mémoriser.
    const getList = () => host.shadowRoot?.querySelector('.join-widget-list') ?? null;
    const getCells = (list) => Array.from(list.querySelectorAll('.join-widget-element'));
    const getMaxScroll = (list) => Math.max(0, list.scrollWidth - list.clientWidth);

    // Indices (0-based) de la première et de la dernière carte entièrement visibles,
    // ou null si aucune ne l'est (en cours de défilement animé).
    const getVisibleRange = (list, cells) => {
      const listRect = list.getBoundingClientRect();
      const styles = getComputedStyle(list);
      const start = listRect.left + (parseFloat(styles.paddingLeft) || 0);
      // L'hôte déborde du wrapper de son padding : on s'arrête au bord du viewport.
      const end = Math.min(
        listRect.right - (parseFloat(styles.paddingRight) || 0),
        document.documentElement.clientWidth
      );

      let first = -1;
      let last = -1;

      cells.forEach((cell, index) => {
        const rect = (cell.querySelector('.join-card-container') || cell).getBoundingClientRect();
        if (rect.left < start - 1 || rect.right > end + 1) return;

        if (first === -1) first = index;
        last = index;
      });

      return first === -1 ? null : { first, last };
    };

    const updateControls = () => {
      if (!controls) return;

      const list = getList();
      const cells = list ? getCells(list) : [];
      const maxScroll = list ? getMaxScroll(list) : 0;

      // Rien à faire défiler : widget pas encore monté, ou toutes les stories tiennent dans la vue.
      controls.hidden = maxScroll <= 1;
      if (!list) return;

      const scrollLeft = Math.round(list.scrollLeft);
      prevButton.disabled = scrollLeft <= 1;
      nextButton.disabled = scrollLeft >= Math.round(maxScroll) - 1;
      totalEl.textContent = String(cells.length);

      // Plage visible ("4–6") plutôt que la seule première carte : en fin de liste
      // le compteur atteint le total, et il dit ce que l'on voit réellement.
      const range = getVisibleRange(list, cells);
      if (!range) return;

      currentSlideEl.textContent =
        range.first === range.last ? String(range.first + 1) : `${range.first + 1}–${range.last + 1}`;
    };

    let updateScheduled = false;
    const scheduleUpdate = () => {
      if (updateScheduled) return;

      updateScheduled = true;
      requestAnimationFrame(() => {
        updateScheduled = false;
        updateControls();
        if (host.shadowRoot) primeUgcStoriesCovers(host.shadowRoot);
      });
    };

    const scrollByStep = (direction) => {
      const list = getList();
      const cell = list?.querySelector('.join-widget-element');
      if (!list || !cell) return;

      const step = cell.getBoundingClientRect().width;
      const target = Math.min(Math.max(0, list.scrollLeft + step * direction), getMaxScroll(list));

      list.scrollTo({ left: target, behavior: 'smooth' });
    };

    prevButton?.addEventListener('click', () => scrollByStep(-1));
    nextButton?.addEventListener('click', () => scrollByStep(1));

    const onWidgetMounted = (shadowRoot) => {
      injectUgcStoriesShadowStyle(shadowRoot);
      primeUgcStoriesCovers(shadowRoot);

      // `scroll` ne remonte pas mais traverse la phase de capture : écouté sur le
      // shadow root, il suit la liste même si Join la remplace.
      shadowRoot.addEventListener('scroll', scheduleUpdate, { capture: true, passive: true });
      shadowRoot.addEventListener('scrollend', scheduleUpdate, { capture: true });
      // Cartes ajoutées, classes can-scroll-* posées par Join, re-render, vignette en
      // échec remplacée par une cover vidéo (data-thumbnail-error).
      new MutationObserver(scheduleUpdate).observe(shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-thumbnail-error'],
      });
      new ResizeObserver(scheduleUpdate).observe(host);

      updateControls();
    };

    // Le widget se monte de façon asynchrone (script Join différé + fetch des
    // stories) sans émettre d'événement : on sonde jusqu'à l'apparition de sa liste.
    const start = performance.now();
    const waitForWidget = () => {
      const shadowRoot = host.shadowRoot;

      if (shadowRoot?.querySelector('.join-widget-list')) {
        onWidgetMounted(shadowRoot);
        return;
      }

      if (!section.isConnected || performance.now() - start > UGC_STORIES_POLL_TIMEOUT) return;
      setTimeout(waitForWidget, UGC_STORIES_POLL_INTERVAL);
    };

    waitForWidget();

    // Repli pour les navigateurs sans unités de container query (Safari < 16,
    // Chrome < 105, Firefox < 110) : la largeur du wrapper est fournie en px.
    if (!UGC_STORIES_SUPPORTS_CQW && wrapper) {
      const applyContainerWidth = () => {
        const styles = getComputedStyle(wrapper);
        const width =
          wrapper.clientWidth -
          (parseFloat(styles.paddingLeft) || 0) -
          (parseFloat(styles.paddingRight) || 0);

        host.style.setProperty('--ugc-stories-container-width', `${Math.max(0, width)}px`);
      };

      applyContainerWidth();
      new ResizeObserver(applyContainerWidth).observe(wrapper);
    }
  }

  function initUgcStoriesSections(root = document) {
    root.querySelectorAll('[js-ugc-stories]').forEach(initUgcStories);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initUgcStoriesSections());
  } else {
    initUgcStoriesSections();
  }

  document.addEventListener('shopify:section:load', (event) => initUgcStoriesSections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('ugc-block')) {
    class UgcBlock extends HTMLElement {
      #videoMedia;

      connectedCallback() {
        this.#videoMedia = this.querySelector('video-media');
        this.bindVideoListener();
        this.bindTouchRevealListener();
      }

      play() {
        if (!this.#videoMedia) return;

        this.#videoMedia.setAttribute('loaded', '');
        this.#videoMedia.play();
      }

      pause() {
        if (!this.#videoMedia) return;

        this.#videoMedia.pause();
        this.#videoMedia.removeAttribute('loaded');
        this.#videoMedia.removeAttribute('playing');
      }

      bindVideoListener() {
        if (!this.#videoMedia) return;

        this.#videoMedia.addEventListener('click', (event) => {
          event.preventDefault();
          this.#videoMedia.playing ? this.pause() : this.play();
        });
      }

      bindTouchRevealListener() {
        const product = this.querySelector('[js-ugc-product]');
        if (!product) return;

        product.addEventListener('click', (event) => {
          if (!window.matchMedia('(hover: none)').matches) return;

          const link = event.target.closest('[data-ugc-product-link]');
          const isProductAnchor =
            event.target instanceof HTMLAnchorElement &&
            product.contains(event.target);

          if (this.classList.contains('is-revealed') && (link || isProductAnchor))
            return;
          if (this.classList.contains('is-revealed')) return;

          event.preventDefault();

          this.closest('[js-ugc-carousel]')
            ?.querySelectorAll('[js-ugc-block].is-revealed')
            .forEach((block) => block.classList.remove('is-revealed'));

          this.classList.add('is-revealed');
        });
      }
    }

    window.customElements.define('ugc-block', UgcBlock);
  }

  function initUgcCarousel(section) {
    const carousel = section.querySelector('[js-ugc-carousel]');
    if (!carousel || carousel.dataset.ugcNavInit) return;

    carousel.dataset.ugcNavInit = 'true';

    const prevBtn = section.querySelector('[js-ugc-prev]');
    const nextBtn = section.querySelector('[js-ugc-next]');
    const cells = () => Array.from(carousel.querySelectorAll('[js-ugc-block]'));
    const currentSlideEl = section.querySelector('[current-slide-index]');

    const getLeadingIndex = () => {
      const items = cells();
      if (!items.length) return 0;

      const viewportLeft = carousel.getBoundingClientRect().left;

      return items.reduce((leading, cell, index) => {
        const distance = Math.abs(cell.getBoundingClientRect().left - viewportLeft);
        const leadingDistance = Math.abs(
          items[leading].getBoundingClientRect().left - viewportLeft
        );
        return distance < leadingDistance ? index : leading;
      }, 0);
    };

    const updateIndicator = () => {
      if (!currentSlideEl) return;
      currentSlideEl.textContent = String(getLeadingIndex() + 1);
    };

    const getStep = () => {
      const cell = carousel.querySelector('[js-ugc-block]');
      if (!cell) return 0;

      const gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
      return cell.offsetWidth + gap;
    };

    const maxScroll = () => Math.max(0, carousel.scrollWidth - carousel.clientWidth);

    const updateButtons = () => {
      const scrollLeft = Math.round(carousel.scrollLeft);
      const end = Math.round(maxScroll());

      if (prevBtn) prevBtn.disabled = scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = scrollLeft >= end - 1;
    };

    const scrollByStep = (direction) => {
      const step = getStep();
      if (!step) return;

      const target = Math.min(
        Math.max(0, carousel.scrollLeft + step * direction),
        maxScroll()
      );

      carousel.scrollTo({ left: target, behavior: 'smooth' });
    };

    prevBtn?.addEventListener('click', () => scrollByStep(-1));
    nextBtn?.addEventListener('click', () => scrollByStep(1));
    carousel.addEventListener('scroll', updateButtons, { passive: true });
    carousel.addEventListener('scroll', () => requestAnimationFrame(updateIndicator), {
      passive: true,
    });
    carousel.addEventListener('scrollend', () => {
      updateButtons();
      requestAnimationFrame(() => requestAnimationFrame(updateIndicator));
    });

    new ResizeObserver(() => {
      carousel.scrollLeft = Math.min(carousel.scrollLeft, maxScroll());
      updateButtons();
    }).observe(carousel);

    requestAnimationFrame(() => {
      carousel.scrollLeft = 0;
      updateButtons();
      updateIndicator();
    });
  }

  function initUgcCarousels(root = document) {
    root.querySelectorAll('.ugc').forEach(initUgcCarousel);
  }

  document.addEventListener('DOMContentLoaded', () => initUgcCarousels());
  document.addEventListener('shopify:section:load', (event) => initUgcCarousels(event.target));

  } catch(e) { console.error(e); }
})();
})();
